/**
 * Clase que contiene todas las constantes transversales del sistema
 */
export class TransversalConstant {
  static readonly CONTENT: string = 'application/json;charset=UTF-8';
  static readonly ID_ADMINISTRADOR: number = -1;
  static readonly ID_USUARIO_NO_EXISTE: number = 0;
  static readonly BAD_REQUEST: number = 400;
  static readonly UNAUTHORIZED: number = 401;
  static readonly ID_APLICACION_BACKOFFICE = 1;
  static readonly ID_APLICACION_VENTAS = 2;
}
